import React from 'react'
import { Link } from 'react-router-dom'

const Breadcrums = ({ pages = [], active }) => {
  return (
     <nav className="text-sm font-medium ">
      <ol className="flex items-center space-x-1">
        {/* Home */}
        {/* <li className="flex items-center">
          <Link
            to="/"
            className="text-black hover:underline"
          >
            Home
          </Link>
        </li> */}

        {/* Dynamic Pages */}
        {pages.map((e, i) => (
          <li key={i} className="flex items-center">
            {i !== 0 && <span className="mx-1 text-black">/</span>}
            {e.link ? (
              <Link
                to={`/${e.link}`}
                className="text-black hover:underline"
              >
                {e.title}
              </Link>
            ) : (
              <span className="text-red-600 font-semibold">{e.title}</span>
            )}
          </li>
        ))}

        {/* Active Page */}
        {active && (
          <li className="flex items-center">
            <span className="mx-1 text-gray-400">/</span>
            <span className="text-red-600 font-semibold">{active}</span>
          </li>
        )}
      </ol>
    </nav>
  )
}

export default Breadcrums